import Gallery from './Gallery';
import ImageGallery from './ImageGallery';
import LazyImage from './LazyImage';

export const photoElements = {
    Gallery,
    ImageGallery,
    LazyImage,
};
